"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRequisitionListFromRequisitionControllerStatusEnum = exports.GetRequisitionListFromRequisitionControllerOrderTypeEnum = exports.GetRequisitionListFromRequisitionControllerOrderStageEnum = exports.RequisitionApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var RequisitionApi = /** @class */ (function (_super) {
    __extends(RequisitionApi, _super);
    function RequisitionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * marks the RQ as complete and returns the updated rq review status
     */
    RequisitionApi.prototype.completeRqReviewFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling completeRqReviewFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/complete-rq-review".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RqReviewStatusDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * marks the RQ as complete and returns the updated rq review status
     */
    RequisitionApi.prototype.completeRqReviewFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.completeRqReviewFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create blank requisition.
     */
    RequisitionApi.prototype.createBlankRequisitionFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.accessionedRequisitionRequestDto === null || requestParameters.accessionedRequisitionRequestDto === undefined) {
                            throw new runtime.RequiredError('accessionedRequisitionRequestDto', 'Required parameter requestParameters.accessionedRequisitionRequestDto was null or undefined when calling createBlankRequisitionFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/blank",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.AccessionedRequisitionRequestDtoToJSON)(requestParameters.accessionedRequisitionRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequisitionItemResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create blank requisition.
     */
    RequisitionApi.prototype.createBlankRequisitionFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createBlankRequisitionFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new message, optionally a new conversation or participant
     */
    RequisitionApi.prototype.createConversationFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling createConversationFromRequisitionController.');
                        }
                        if (requestParameters.newConversationRequestDto === null || requestParameters.newConversationRequestDto === undefined) {
                            throw new runtime.RequiredError('newConversationRequestDto', 'Required parameter requestParameters.newConversationRequestDto was null or undefined when calling createConversationFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/conversations".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.NewConversationRequestDtoToJSON)(requestParameters.newConversationRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ConversationDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new message, optionally a new conversation or participant
     */
    RequisitionApi.prototype.createConversationFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createConversationFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new note for a requisition
     */
    RequisitionApi.prototype.createNoteFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling createNoteFromRequisitionController.');
                        }
                        if (requestParameters.newNotePayload === null || requestParameters.newNotePayload === undefined) {
                            throw new runtime.RequiredError('newNotePayload', 'Required parameter requestParameters.newNotePayload was null or undefined when calling createNoteFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/notes".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.NewNotePayloadToJSON)(requestParameters.newNotePayload),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequisitionNoteResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new note for a requisition
     */
    RequisitionApi.prototype.createNoteFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createNoteFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a list of active carrier couple consents for this requisition
     */
    RequisitionApi.prototype.getActiveCarrierCouplesConsentsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getActiveCarrierCouplesConsentsFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{id}/carrier-couples-consents/active-consents".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RequisitionActiveCarrierCouplesConsentsResponseDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns a list of active carrier couple consents for this requisition
     */
    RequisitionApi.prototype.getActiveCarrierCouplesConsentsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getActiveCarrierCouplesConsentsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Download an attachment by requisition and attachment id
     */
    RequisitionApi.prototype.getAttachmentFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getAttachmentFromRequisitionController.');
                        }
                        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
                            throw new runtime.RequiredError('attachmentId', 'Required parameter requestParameters.attachmentId was null or undefined when calling getAttachmentFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{id}/attachments/{attachmentId}/download".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))).replace("{".concat("attachmentId", "}"), encodeURIComponent(String(requestParameters.attachmentId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Download an attachment by requisition and attachment id
     */
    RequisitionApi.prototype.getAttachmentFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAttachmentFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns a list of all carrier couple consents for this requisition
     */
    RequisitionApi.prototype.getCarrierCouplesConsentsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCarrierCouplesConsentsFromRequisitionController.');
                        }
                        if (requestParameters.includePartnerConsents === null || requestParameters.includePartnerConsents === undefined) {
                            throw new runtime.RequiredError('includePartnerConsents', 'Required parameter requestParameters.includePartnerConsents was null or undefined when calling getCarrierCouplesConsentsFromRequisitionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.includePartnerConsents !== undefined) {
                            queryParameters['includePartnerConsents'] = requestParameters.includePartnerConsents;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{id}/carrier-couples-consents".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RequisitionCarrierCouplesConsentsResponseDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns a list of all carrier couple consents for this requisition
     */
    RequisitionApi.prototype.getCarrierCouplesConsentsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCarrierCouplesConsentsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the clinical team for a requisition
     */
    RequisitionApi.prototype.getClinicalTeamFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getClinicalTeamFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/clinical-team".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ClinicalTeamDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the clinical team for a requisition
     */
    RequisitionApi.prototype.getClinicalTeamFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getClinicalTeamFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the paginated list of messages for a Requisition
     */
    RequisitionApi.prototype.getConversationsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getConversationsFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/conversations".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.ConversationDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns the paginated list of messages for a Requisition
     */
    RequisitionApi.prototype.getConversationsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getConversationsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the gestational age for a requisition
     */
    RequisitionApi.prototype.getGestationalAgeFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getGestationalAgeFromRequisitionController.');
                        }
                        if (requestParameters.estimatedDueDate === null || requestParameters.estimatedDueDate === undefined) {
                            throw new runtime.RequiredError('estimatedDueDate', 'Required parameter requestParameters.estimatedDueDate was null or undefined when calling getGestationalAgeFromRequisitionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.estimatedDueDate !== undefined) {
                            queryParameters['estimatedDueDate'] = requestParameters.estimatedDueDate;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/gestational-age".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.GestationalAgeDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the gestational age for a requisition
     */
    RequisitionApi.prototype.getGestationalAgeFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGestationalAgeFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the notes for a requisition
     */
    RequisitionApi.prototype.getNotesFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getNotesFromRequisitionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['perPage'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/notes".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedRequisitionNotesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the notes for a requisition
     */
    RequisitionApi.prototype.getNotesFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNotesFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the reasons for testing data for a requisition
     */
    RequisitionApi.prototype.getReasonsForTestingFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getReasonsForTestingFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/reasons-for-testing".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ReasonsForTestingDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the reasons for testing data for a requisition
     */
    RequisitionApi.prototype.getReasonsForTestingFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReasonsForTestingFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns reported variants for a requisition
     */
    RequisitionApi.prototype.getReportedVariantOptionsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getReportedVariantOptionsFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/reported-variants".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ReportedVariantOptionsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns reported variants for a requisition
     */
    RequisitionApi.prototype.getReportedVariantOptionsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getReportedVariantOptionsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a requisition
     */
    RequisitionApi.prototype.getRequisitionFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getRequisitionFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequisitionItemResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a requisition
     */
    RequisitionApi.prototype.getRequisitionFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequisitionFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a list of requisition reviews
     */
    RequisitionApi.prototype.getRequisitionListFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.q !== undefined) {
                            queryParameters['q'] = requestParameters.q;
                        }
                        if (requestParameters.eid !== undefined) {
                            queryParameters['eid'] = requestParameters.eid;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['perPage'] = requestParameters.perPage;
                        }
                        if (requestParameters.orderStage !== undefined) {
                            queryParameters['orderStage'] = requestParameters.orderStage;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        if (requestParameters.orderType) {
                            queryParameters['orderType'] = requestParameters.orderType;
                        }
                        if (requestParameters.studyCode) {
                            queryParameters['studyCode'] = requestParameters.studyCode;
                        }
                        if (requestParameters.status) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.countries) {
                            queryParameters['countries'] = requestParameters.countries;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/requisition-list",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequisitionListResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a list of requisition reviews
     */
    RequisitionApi.prototype.getRequisitionListFromRequisitionController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequisitionListFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns paginated list of requisitions with the ability to filter by requisition ids or specimen ids
     */
    RequisitionApi.prototype.getRequisitionsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.paginator !== undefined) {
                            queryParameters['paginator'] = requestParameters.paginator;
                        }
                        if (requestParameters.dateModifiedGte !== undefined) {
                            queryParameters['dateModifiedGte'] = requestParameters.dateModifiedGte;
                        }
                        if (requestParameters.dateModifiedGt !== undefined) {
                            queryParameters['dateModifiedGt'] = requestParameters.dateModifiedGt;
                        }
                        if (requestParameters.dateModifiedLte !== undefined) {
                            queryParameters['dateModifiedLte'] = requestParameters.dateModifiedLte;
                        }
                        if (requestParameters.dateModifiedLt !== undefined) {
                            queryParameters['dateModifiedLt'] = requestParameters.dateModifiedLt;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['perPage'] = requestParameters.perPage;
                        }
                        if (requestParameters.reqids) {
                            queryParameters['reqids'] = requestParameters.reqids;
                        }
                        if (requestParameters.specimenSids) {
                            queryParameters['specimenSids'] = requestParameters.specimenSids;
                        }
                        if (requestParameters.orderIds) {
                            queryParameters['orderIds'] = requestParameters.orderIds;
                        }
                        if (requestParameters.fields) {
                            queryParameters['fields'] = requestParameters.fields;
                        }
                        if (requestParameters.include) {
                            queryParameters['include'] = requestParameters.include;
                        }
                        if (requestParameters.canceled !== undefined) {
                            queryParameters['canceled'] = requestParameters.canceled;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/requisitions",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedRequisitionsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns paginated list of requisitions with the ability to filter by requisition ids or specimen ids
     */
    RequisitionApi.prototype.getRequisitionsFromRequisitionController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRequisitionsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns specimens information
     */
    RequisitionApi.prototype.getSpecimensFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling getSpecimensFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/specimens".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RequisitionSpecimenWithLabelDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns specimens information
     */
    RequisitionApi.prototype.getSpecimensFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSpecimensFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the list of activity for the given requisition
     */
    RequisitionApi.prototype.listActivityFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling listActivityFromRequisitionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.hideClinicalInformation !== undefined) {
                            queryParameters['hideClinicalInformation'] = requestParameters.hideClinicalInformation;
                        }
                        if (requestParameters.includeSmsStatus !== undefined) {
                            queryParameters['includeSmsStatus'] = requestParameters.includeSmsStatus;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/activity".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RequisitionActivityDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns the list of activity for the given requisition
     */
    RequisitionApi.prototype.listActivityFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listActivityFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List attachments attached to a requisition
     */
    RequisitionApi.prototype.listAttachmentsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling listAttachmentsFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{id}/attachments".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.BackofficeRequisitionAttachmentsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List attachments attached to a requisition
     */
    RequisitionApi.prototype.listAttachmentsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listAttachmentsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates requisition \'clinical_follow_up\' tag
     */
    RequisitionApi.prototype.patchClinicalFollowUpFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling patchClinicalFollowUpFromRequisitionController.');
                        }
                        if (requestParameters.clinicalFollowUpRequestBody === null || requestParameters.clinicalFollowUpRequestBody === undefined) {
                            throw new runtime.RequiredError('clinicalFollowUpRequestBody', 'Required parameter requestParameters.clinicalFollowUpRequestBody was null or undefined when calling patchClinicalFollowUpFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/clinical-follow-up".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.ClinicalFollowUpRequestBodyToJSON)(requestParameters.clinicalFollowUpRequestBody),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SuccessBooleanResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates requisition \'clinical_follow_up\' tag
     */
    RequisitionApi.prototype.patchClinicalFollowUpFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchClinicalFollowUpFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patches a note for a requisition
     */
    RequisitionApi.prototype.patchNoteFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling patchNoteFromRequisitionController.');
                        }
                        if (requestParameters.noteId === null || requestParameters.noteId === undefined) {
                            throw new runtime.RequiredError('noteId', 'Required parameter requestParameters.noteId was null or undefined when calling patchNoteFromRequisitionController.');
                        }
                        if (requestParameters.patchNotePayloadDto === null || requestParameters.patchNotePayloadDto === undefined) {
                            throw new runtime.RequiredError('patchNotePayloadDto', 'Required parameter requestParameters.patchNotePayloadDto was null or undefined when calling patchNoteFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/notes/{noteId}".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))).replace("{".concat("noteId", "}"), encodeURIComponent(String(requestParameters.noteId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PatchNotePayloadDtoToJSON)(requestParameters.patchNotePayloadDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequisitionNoteResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patches a note for a requisition
     */
    RequisitionApi.prototype.patchNoteFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchNoteFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates a requisition clinical team, practice/owner/ordering_clinician/delegates
     */
    RequisitionApi.prototype.patchRequisitionClinicalTeamFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling patchRequisitionClinicalTeamFromRequisitionController.');
                        }
                        if (requestParameters.patchRequisitionClinicalTeamDto === null || requestParameters.patchRequisitionClinicalTeamDto === undefined) {
                            throw new runtime.RequiredError('patchRequisitionClinicalTeamDto', 'Required parameter requestParameters.patchRequisitionClinicalTeamDto was null or undefined when calling patchRequisitionClinicalTeamFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PatchRequisitionClinicalTeamDtoToJSON)(requestParameters.patchRequisitionClinicalTeamDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates a requisition clinical team, practice/owner/ordering_clinician/delegates
     */
    RequisitionApi.prototype.patchRequisitionClinicalTeamFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchRequisitionClinicalTeamFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create a Medical Necessity Letter and optionally upload the PDF for a requisition
     */
    RequisitionApi.prototype.postMedicalNecessityLetterFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling postMedicalNecessityLetterFromRequisitionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.allowUnconfirmedFields !== undefined) {
                            queryParameters['allowUnconfirmedFields'] = requestParameters.allowUnconfirmedFields;
                        }
                        if (requestParameters.upload !== undefined) {
                            queryParameters['upload'] = requestParameters.upload;
                        }
                        if (requestParameters.adminMode !== undefined) {
                            queryParameters['adminMode'] = requestParameters.adminMode;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{id}/medical-necessity-letter".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Create a Medical Necessity Letter and optionally upload the PDF for a requisition
     */
    RequisitionApi.prototype.postMedicalNecessityLetterFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postMedicalNecessityLetterFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Updates the last_viewed at field and returns the updated rq review status
     */
    RequisitionApi.prototype.rqReviewStatusFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling rqReviewStatusFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/rq-review-status".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RqReviewStatusDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the last_viewed at field and returns the updated rq review status
     */
    RequisitionApi.prototype.rqReviewStatusFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rqReviewStatusFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a list of requisition identifiers based on reqid search qp
     */
    RequisitionApi.prototype.searchRequisitionIdsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.search === null || requestParameters.search === undefined) {
                            throw new runtime.RequiredError('search', 'Required parameter requestParameters.search was null or undefined when calling searchRequisitionIdsFromRequisitionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['perPage'] = requestParameters.perPage;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/search-reqids",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PaginatedReqidSearchResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a list of requisition identifiers based on reqid search qp
     */
    RequisitionApi.prototype.searchRequisitionIdsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchRequisitionIdsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Search by: patient name, email, dob, mrn; requisition_ids or specimen_ids. At least one search criteria is required.
     * Search for requisitions
     */
    RequisitionApi.prototype.searchRequisitionsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.requisitionSearchRequestDto === null || requestParameters.requisitionSearchRequestDto === undefined) {
                            throw new runtime.RequiredError('requisitionSearchRequestDto', 'Required parameter requestParameters.requisitionSearchRequestDto was null or undefined when calling searchRequisitionsFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/search",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.RequisitionSearchRequestDtoToJSON)(requestParameters.requisitionSearchRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.FoundRequisitionDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Search by: patient name, email, dob, mrn; requisition_ids or specimen_ids. At least one search criteria is required.
     * Search for requisitions
     */
    RequisitionApi.prototype.searchRequisitionsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchRequisitionsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns FVT suggestions given the current state of FVT details for an RQ
     */
    RequisitionApi.prototype.suggestionsForFvtFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.suggestionsFVTDetailsDto === null || requestParameters.suggestionsFVTDetailsDto === undefined) {
                            throw new runtime.RequiredError('suggestionsFVTDetailsDto', 'Required parameter requestParameters.suggestionsFVTDetailsDto was null or undefined when calling suggestionsForFvtFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/suggestions-for-fvt",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SuggestionsFVTDetailsDtoToJSON)(requestParameters.suggestionsFVTDetailsDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.FVTSuggestionsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns FVT suggestions given the current state of FVT details for an RQ
     */
    RequisitionApi.prototype.suggestionsForFvtFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.suggestionsForFvtFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates requisition price
     */
    RequisitionApi.prototype.updatePricingFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling updatePricingFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/update-pricing".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequisitionPricingDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates requisition price
     */
    RequisitionApi.prototype.updatePricingFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePricingFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add an attachment to the given requisition.
     */
    RequisitionApi.prototype.uploadAttachmentsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling uploadAttachmentsFromRequisitionController.');
                        }
                        if (requestParameters.requisitionAttachmentRequestDto === null || requestParameters.requisitionAttachmentRequestDto === undefined) {
                            throw new runtime.RequiredError('requisitionAttachmentRequestDto', 'Required parameter requestParameters.requisitionAttachmentRequestDto was null or undefined when calling uploadAttachmentsFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{id}/attachments".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.RequisitionAttachmentRequestDtoToJSON)(requestParameters.requisitionAttachmentRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequisitionAttachmentResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Add an attachment to the given requisition.
     */
    RequisitionApi.prototype.uploadAttachmentsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.uploadAttachmentsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns reported variants for a requisition
     */
    RequisitionApi.prototype.validateVariantsAndGenesFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.variantsAndCommercialTestsRequestDto === null || requestParameters.variantsAndCommercialTestsRequestDto === undefined) {
                            throw new runtime.RequiredError('variantsAndCommercialTestsRequestDto', 'Required parameter requestParameters.variantsAndCommercialTestsRequestDto was null or undefined when calling validateVariantsAndGenesFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/validate-variants-and-genes",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.VariantsAndCommercialTestsRequestDtoToJSON)(requestParameters.variantsAndCommercialTestsRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.VariantValidatorResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns reported variants for a requisition
     */
    RequisitionApi.prototype.validateVariantsAndGenesFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateVariantsAndGenesFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Verify specimen
     */
    RequisitionApi.prototype.verifySpecimenFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqid === null || requestParameters.reqid === undefined) {
                            throw new runtime.RequiredError('reqid', 'Required parameter requestParameters.reqid was null or undefined when calling verifySpecimenFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{reqid}/verify-specimen".replace("{".concat("reqid", "}"), encodeURIComponent(String(requestParameters.reqid))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SpecimenVerificationResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Verify specimen
     */
    RequisitionApi.prototype.verifySpecimenFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifySpecimenFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    RequisitionApi.prototype.youScriptResultsFromRequisitionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling youScriptResultsFromRequisitionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/requisition/{id}/youscript-results".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    RequisitionApi.prototype.youScriptResultsFromRequisitionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.youScriptResultsFromRequisitionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return RequisitionApi;
}(runtime.BaseAPI));
exports.RequisitionApi = RequisitionApi;
/**
 * @export
 */
exports.GetRequisitionListFromRequisitionControllerOrderStageEnum = {
    OrderSubmitted: 'ORDER_SUBMITTED',
    SpecimenReceived: 'SPECIMEN_RECEIVED',
    LabProcessing: 'LAB_PROCESSING',
    PreCropHold: 'PRE_CROP_HOLD',
    AnalysisAndInterpretation: 'ANALYSIS_AND_INTERPRETATION',
    PostCropHold: 'POST_CROP_HOLD',
    ReportReleased: 'REPORT_RELEASED',
    OnHold: 'ON_HOLD',
    OrderProcessing: 'ORDER_PROCESSING',
    RqReview: 'RQ_REVIEW'
};
/**
 * @export
 */
exports.GetRequisitionListFromRequisitionControllerOrderTypeEnum = {
    Carrier: 'carrier',
    CombiCc: 'combi_cc',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiPfu: 'combi_pfu',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    Diagnostic: 'diagnostic',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Nips: 'nips',
    Pgx: 'pgx',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    SolidTumor: 'solid_tumor',
    Stat: 'stat',
    TumorProfiling: 'tumor_profiling',
    Wgs: 'wgs'
};
/**
 * @export
 */
exports.GetRequisitionListFromRequisitionControllerStatusEnum = {
    ClinicalFollowUp: 'clinical_follow_up',
    IsVerificationOnly: 'is_verification_only',
    NoStatus: 'no_status'
};
